export function leadingZero(number, length = 2) {
	if ((''+number).length > length) {
		return number;
	}
	return ('0'.repeat(length) + number).slice((length * -1));
}

export default leadingZero;